import { useContext, useEffect } from 'react';
import { SecondaryHeaderContext } from '../contexts/secondary-header';

/**
 * Register a node into the layout's secondary header strip.
 * Pass a factory function + deps (same contract as useCallback/useEffect).
 * The header is re-rendered only when deps change and cleared on unmount.
 */
export function useSecondaryHeader(factory, deps) {
  const { setHeader, clearHeader } = useContext(SecondaryHeaderContext);

  useEffect(() => {
    setHeader(factory());
    return () => clearHeader();
    // deps intentionally forwarded — caller controls when header updates
  }, deps);
}
